export interface Salary_Ezafekar_Interface {
    id:number,
    year:number,
    month:number,
    ezafekar:number,
    person_id:number,
}


export function Empty_Salary_Ezafekar_Interface():Salary_Ezafekar_Interface{
  return{
    id:0,
    year:0,
    month:0,
    ezafekar:0,
    person_id:0,   
  }
}